import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../firebase/auth";
import { db } from "../../firebase/firestore";
import { doc, getDoc } from "firebase/firestore";
import Sidebar from "./components/Sidebar";

// CORE
import Items from "./components/Items";
import Orders from "./components/Orders";
import Offers from "./components/Offers";
import Users from "./components/Users";

// NEW PRO FEATURES
import Analytics from "./components/Analytics";
import Inventory from "./components/Inventory";
import Banners from "./components/Banners";
import Notifications from "./components/Notifications";
import Support from "./components/Support";
import PlatformControl from "./components/PlatformControl";
import "./dashboard.css";

export default function Dashboard() {
  const [active, setActive] = useState("analytics");
  const [authReady, setAuthReady] = useState(false);
  const [isAuthed, setIsAuthed] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Keep dashboard scroll unlocked on small screens.
    document.body.classList.add("admin-scroll-unlock");
    document.documentElement.classList.add("admin-scroll-unlock");
    document.getElementById("root")?.classList.add("admin-scroll-unlock");

    return () => {
      document.body.classList.remove("admin-scroll-unlock");
      document.documentElement.classList.remove("admin-scroll-unlock");
      document.getElementById("root")?.classList.remove("admin-scroll-unlock");
    };
  }, []);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      setIsAuthed(Boolean(user));
      setIsAdmin(false);
      setAuthReady(true);

      if (!user?.uid) {
        return;
      }

      getDoc(doc(db, "users", user.uid))
        .then((snap) => {
          const role = String(snap.data()?.role || "").toLowerCase();
          setIsAdmin(role === "admin");
        })
        .catch(() => {
          setIsAdmin(false);
        });
    });

    return () => unsub();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    navigate("/");
  };

  const renderPage = () => {
    switch (active) {
      case "analytics": return <Analytics />;
      case "items": return <Items />;
      case "orders": return <Orders />;
      case "offers": return <Offers />;
      case "users": return <Users />;
      case "inventory": return <Inventory />;
      case "banners": return <Banners />;
      case "notifications": return <Notifications />;
      case "support": return <Support />;
      case "platform": return <PlatformControl />;
      default: return <Analytics />;
    }
  };

  return (
    <div className="admin-layout">

      {/* SIDEBAR */}
      <Sidebar active={active} setActive={setActive} />

      {/* MAIN */}
      <div className="admin-content">

        {/* NAVBAR */}
        <div className="top-navbar">
          <h2>🚀 Admin Control Panel</h2>

          <div className="nav-actions">
            <button className="nav-btn">🔔</button>
            <button className="logout-btn" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </div>

        {/* HERO */}
        <div className="hero-box">
          <h1>Welcome Back 👋</h1>
          <p>Control your entire food business from here</p>

          <div className="hero-stats">
            <div className="stat">💰 Revenue</div>
            <div className="stat">📦 Orders</div>
            <div className="stat">👤 Users</div>
          </div>
        </div>

        {/* PAGE */}
        <div className="page-content">
          {!authReady ? (
            <div className="card">Checking session...</div>
          ) : !isAuthed ? (
            <div className="card admin-auth-warning">
              <h3>Session expired</h3>
              <p>Please log in again to load live database data.</p>
              <button type="button" onClick={() => navigate("/")}>Go To Login</button>
            </div>
          ) : !isAdmin ? (
            <div className="card admin-auth-warning">
              <h3>No Admin Access</h3>
              <p>Your account is logged in but does not have admin role in database.</p>
              <button type="button" onClick={() => navigate("/")}>Back</button>
            </div>
          ) : (
            renderPage()
          )}
        </div>

      </div>
    </div>
  );
}